/**
 * Personnel Domain - i18n Translations
 *
 * Organized translation namespaces:
 * - personnel: Shared content (section header, tabs, common buttons)
 * - roles: Role-specific translations
 * - personnel-employees: Employee-specific translations (namespaced to avoid conflicts)
 *
 * @example
 * // Register domain translations at app initialization
 * import { registerPersonnelTranslations } from 'domains/personnel';
 * registerPersonnelTranslations();
 */

import esPersonnel from './es-MX/personnel.json';
import enPersonnel from './en-US/personnel.json';
import esRoles from './es-MX/roles.json';
import enRoles from './en-US/roles.json';
import esEmployees from './es-MX/personnel-employees.json';
// import enEmployees from './en-US/employees.json';

export const personnelTranslations = {
  'es-MX': esPersonnel,
  'en-US': enPersonnel,
};

export const rolesTranslations = {
  'es-MX': esRoles,
  'en-US': enRoles,
};

export const employeesTranslations = {
  'es-MX': esEmployees,
  // 'en-US': enEmployees,
};

// Combined export for convenience
export const allPersonnelTranslations = {
  personnel: personnelTranslations,
  roles: rolesTranslations,
  employees: employeesTranslations,
};

// Export registration functions
export { registerPersonnelTranslations, arePersonnelTranslationsLoaded } from './registerTranslations';
